// import { IMesh } from '@seddi/mesh';
import type { BufferGeometry, LoadingManager } from '@seddi/three';
import log from 'loglevel';

import { create as createGeometry } from '../core/bufferGeometry';
import { adapt } from './meshAdapter';
import { load } from './meshLoader';
import { ResourceManager } from './resourceManager';

export class MeshesContext extends ResourceManager<BufferGeometry> {
  /**
   * Loading manager.
   */
  readonly manager: LoadingManager;

  constructor(manager: LoadingManager) {
    super();
    this.manager = manager;
  }

  async loadAsync(desc: any): Promise<BufferGeometry | undefined> {
    if (this.find(desc.id)) {
      log.warn(`MeshesContext.loadAsync: ${desc.id} is not new.`);
      return undefined;
    }

    const item = this.create(desc.id);
    item.status = 'loading';

    let value: BufferGeometry;
    // TODO: Rework avatar mesh integration.
    if (desc.href) {
      value = await load(desc.href, this.manager);
    } else {
      const data = adapt(desc);
      value = createGeometry(data.geometry);
    }

    item.status = 'ready';
    item.value = value;

    if (this.onLoad) {
      this.onLoad(desc.id, 'Mesh');
    }

    return value;
  }
}
